import { prop } from "fw";

import { Team } from "models/team";


export class TeamAvatar {
  @prop(null) team!: Team;
}
